import { Component } from 'react';
import { connect } from 'react-redux';
import { format, subDays } from 'date-fns';
import { PageSection, PageSectionHeader } from 'components/page';
import { DateRangeSelector } from 'components/common/charts';
import { AnalyticsCoursesCompletions, AnalyticsCoursesMostPopular } from '.';

const AnalyticsCoursesSummary = connect((state) => ({
  messages: state.messages,
  user: state.user
}))(
  class extends Component {
    state = {
      fromDate: `${format(subDays(Date.now(), 30), 'y-MM-dd')}T00:00:00`,
      toDate: `${format(Date.now(), 'y-MM-dd')}T23:59:59`
    };

    updateDates = ({ fromDate, toDate }) => {
      this.setState({ fromDate, toDate });
    };

    render() {
      const { messages, user } = this.props;
      const { fromDate, toDate } = this.state;

      return (
        <PageSection>
          <PageSectionHeader
            description={
              user?.roles?.includes('superadmin')
                ? messages.analyticsCoursesDescriptionSuperadmin
                : messages.analyticsCoursesDescriptionAdmin
            }
            title={messages.commonSummary}
          >
            <DateRangeSelector category="light" updateData={this.updateDates} />
          </PageSectionHeader>

          <div className="row-md">
            <div className="col-5of12">
              <AnalyticsCoursesMostPopular
                fromDate={fromDate}
                toDate={toDate}
              />
            </div>
            <div className="col">
              <AnalyticsCoursesCompletions
                fromDate={fromDate}
                toDate={toDate}
              />
            </div>
          </div>
        </PageSection>
      );
    }
  }
);

export default AnalyticsCoursesSummary;
